import { sitePlacement, roomColor, fmtFt } from "@/lib/walls";

const S = 8;

export const SitePlan = ({ plan, site, hideDims = false }) => {
  if (!site) {
    return (
      <div className="h-full grid place-items-center text-center px-6" data-testid="site-empty">
        <p className="font-mono text-xs uppercase tracking-widest text-[var(--muted)]">No lot yet — add your lot size and setbacks in the right panel</p>
      </div>
    );
  }
  const sp = sitePlacement(plan, site);
  const LW = site.lot_width * S, LD = site.lot_depth * S, pad = 60;
  const t = { fontFamily: "JetBrains Mono", fontSize: 10, fill: "#94A3B8", textAnchor: "middle" };
  return (
    <svg viewBox={`${-pad} ${-pad} ${LW + pad * 2} ${LD + pad * 2}`} className="w-full h-full" data-testid="site-plan-svg">
      <text x={LW / 2} y={-34} {...t} fill="#F1F5F9" fontSize={13} fontFamily="Archivo" fontWeight="700">STREET</text>
      <rect x={0} y={0} width={LW} height={LD} fill="#10B981" fillOpacity={0.05} stroke="#10B981" strokeWidth={2} />
      <rect x={site.setback_left * S} y={site.setback_front * S} width={sp.bw * S} height={sp.bd * S}
        fill="none" stroke="#FFB800" strokeWidth={1.5} strokeDasharray="8 5" />
      <g transform={`translate(${sp.hx * S}, ${sp.hy * S})`}>
        {plan.floors[0].rooms.map((r) => (
          <rect key={r.id} x={r.x * S} y={r.y * S} width={r.w * S} height={r.h * S} fill={roomColor(r.type)} fillOpacity={0.12} stroke="#26334D" />
        ))}
        <rect width={plan.width * S} height={plan.depth * S} fill="none" stroke={sp.fits ? "#E2E8F0" : "#F87171"} strokeWidth={3} />
        <text x={plan.width * S / 2} y={plan.depth * S / 2 + 4} {...t} fill="#F1F5F9">{hideDims ? "LOCKED" : `${fmtFt(plan.width)} × ${fmtFt(plan.depth)}`}</text>
      </g>
      <text x={LW / 2} y={-12} {...t}>LOT {fmtFt(site.lot_width)} × {fmtFt(site.lot_depth)}</text>
      <text x={LW / 2} y={site.setback_front * S / 2 + 4} {...t} fill="#FFB800">FRONT {fmtFt(site.setback_front)}</text>
      <text x={LW / 2} y={LD - site.setback_rear * S / 2 + 4} {...t} fill="#FFB800">REAR {fmtFt(site.setback_rear)}</text>
      <text x={-14} y={LD / 2} {...t} fill="#FFB800" transform={`rotate(-90 -14 ${LD / 2})`}>LEFT {fmtFt(site.setback_left)}</text>
      <text x={LW + 14} y={LD / 2} {...t} fill="#FFB800" transform={`rotate(90 ${LW + 14} ${LD / 2})`}>RIGHT {fmtFt(site.setback_right)}</text>
    </svg>
  );
};
